<template>
  <form @submit.prevent="submitForm">
    <div :class="{ invalid: !groupName.isValid }">
      <label for="groupName">Group Name: </label>
      <input
        type="text"
        id="groupName"
        v-model.trim="groupName.val"
        @blur="clearInvalid('groupName')"
      />
      <p v-if="!groupName.isValid">Group Name must not be empty</p>
    </div>
    <div :class="{ invalid: !groupLeader.isValid }">
      <label for="groupLeader">Group Leader: </label>
      <input
        type="text"
        id="groupLeader"
        v-model.trim="groupLeader.val"
        @blur="clearInvalid('groupLeader')"
      />
      <p v-if="!groupLeader.isValid">Group Leader must not be empty</p>
    </div>

    <base-button>Register A New Group</base-button>
  </form>
  <p v-if="!formIsValid">Please fix the above errors and submit again.</p>
</template>


<script>
  export default {
    data() {
      return {
        formIsValid: true,
        groupName: {
                    val: '',
                    isValid: true
                },
        groupLeader: {
                    val: '',
                    isValid: true
                },
      }
    },
    methods: {
      clearInvalid(input) {
          this[input].isValid = true;
      },
      validateForm() {
          this.formIsValid = true;
          if(this.groupName.val === '') {
            this.groupName.isValid = false;
            this.formIsValid = false
          }
           if(this.groupLeader.val === '') {
            this.groupLeader.isValid = false;
            this.formIsValid = false
          }
      },

      submitForm() {
            this.validateForm()
            if(!this.formIsValid) {
              return;
            }
            const group = {
            groupName: this.groupName.val,
            groupLeader: this.groupLeader.val,
            members: [],
            notes: []
            }  

          this.$store.dispatch('groups/registerGroup', group);
            this.$router.replace('/groups')
          }
             
      }
    
  }
</script>

<style scoped>
.invalid label {
  color: red;
}

.invalid input,
.invalid textarea {
  border: 1px solid red;
}
</style>